import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  selectedbdnId: null
};

const bdnIdSlice = createSlice({
  name: 'bdnId',
  initialState,
  reducers: {
    setSelectedbdnId: (state, action) => {
      state.selectedbdnId = action.payload;
    }
  }
});

export const { setSelectedbdnId } = bdnIdSlice.actions;
export default bdnIdSlice.reducer;